module.exports = __webpack_public_path__ + "static/Graphik-SemiboldItalic-Cy-Web-cf4eac87cf414315397b905ba94a8bcc.woff2";